// Fonte: UManutContas.pas ~linha 9215, Ds_Informacoes_Comerciais → tabela Informacoes_Comerciais
// Disponível para: Tipos 1, 2, 4, 8
import React, { useState, useEffect, useCallback } from 'react';
import { Table, Button, Form, Modal, Spinner, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
  listarInfoComerciaisConta,
  inserirInfoComercialConta,
  atualizarInfoComercialConta,
  excluirInfoComercialConta,
} from '~/Services/Service';
import moment from 'moment';
import aplicarMascara from '../components/mascaras';

var VAZIO = { data: '', empresa: '', fone: '', contato: '', valor: '', codigo_ativo: '', informacoes: '' };

var TabInfoComerciais = function(_ref) {
  var ge = _ref.ge;
  var codigo = _ref.codigo;

  var [lista, setLista] = useState([]);
  var [loading, setLoading] = useState(false);
  var [showModal, setShowModal] = useState(false);
  var [editando, setEditando] = useState(null);
  var [form, setForm] = useState(VAZIO);
  var [salvando, setSalvando] = useState(false);
  var [showExcluir, setShowExcluir] = useState(null);

  var carregar = useCallback(function() {
    if (!ge || !codigo) return;
    setLoading(true);
    listarInfoComerciaisConta(ge, codigo)
      .then(function(resp) {
        setLista(Array.isArray(resp) ? resp : []);
      })
      .catch(function() { toast.error('Erro ao carregar informações comerciais'); })
      .finally(function() { setLoading(false); });
  }, [ge, codigo]);

  useEffect(function() { carregar(); }, [carregar]);

  var handleNovo = function() {
    setEditando(null);
    setForm({ ...VAZIO, data: moment().format('YYYY-MM-DD') });
    setShowModal(true);
  };

  var handleEditar = function(item) {
    setEditando(item);
    setForm({
      data: item.data ? moment(item.data).format('YYYY-MM-DD') : '',
      empresa: item.empresa !== null && item.empresa !== undefined ? item.empresa : '',
      fone: item.fone !== null && item.fone !== undefined ? item.fone : '',
      contato: item.contato !== null && item.contato !== undefined ? item.contato : '',
      valor: item.valor !== null && item.valor !== undefined ? item.valor : '',
      codigo_ativo: item.codigo_ativo !== null && item.codigo_ativo !== undefined ? item.codigo_ativo : '',
      informacoes: item.informacoes !== null && item.informacoes !== undefined ? item.informacoes : '',
    });
    setShowModal(true);
  };

  var handleSalvar = function() {
    setSalvando(true);
    var fn = editando
      ? atualizarInfoComercialConta(ge, codigo, { ...form, data: editando.data ? moment(editando.data).format('YYYY-MM-DD') : form.data })
      : inserirInfoComercialConta(ge, codigo, form);
    fn
      .then(function() {
        toast.success('Informação comercial salva!');
        setShowModal(false);
        carregar();
      })
      .catch(function() { toast.error('Erro ao salvar informação comercial'); })
      .finally(function() { setSalvando(false); });
  };

  var handleExcluir = function() {
    excluirInfoComercialConta(ge, codigo, { data: showExcluir.data })
      .then(function() {
        toast.success('Informação comercial excluída!');
        setShowExcluir(null);
        carregar();
      })
      .catch(function() { toast.error('Erro ao excluir'); });
  };

  var handleChange = function(e) {
    var campo = e.target.name;
    var valor = e.target.value;
    setForm(function(f) { return { ...f, [campo]: valor }; });
  };

  return (
    <div className="contas-tab-content">
      <div className="d-flex justify-content-end mb-2">
        <Button size="sm" variant="primary" onClick={handleNovo}>+ Incluir</Button>
      </div>
      {loading ? (
        <div className="text-center py-3"><Spinner animation="border" /></div>
      ) : (
        <Table size="sm" bordered className="contas-sub-grid">
          <thead>
            <tr>
              <th>Data</th>
              <th>Empresa</th>
              <th>Contato</th>
              <th>Valor</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {lista.length === 0 ? (
              <tr><td colSpan={5} className="text-center text-muted">Nenhuma informação comercial</td></tr>
            ) : (
              lista.map(function(item) {
                return (
                  <tr key={item.data ? moment(item.data).toISOString() : Math.random()}>
                    <td>{item.data ? moment(item.data).format('DD/MM/YYYY') : '-'}</td>
                    <td>{item.empresa !== null && item.empresa !== undefined ? item.empresa : '-'}</td>
                    <td>{item.contato !== null && item.contato !== undefined ? item.contato : '-'}</td>
                    <td>{item.valor !== null && item.valor !== undefined ? item.valor : '-'}</td>
                    <td>
                      <Button size="sm" variant="outline-primary" className="mr-1" onClick={function() { handleEditar(item); }}>Editar</Button>
                      <Button size="sm" variant="outline-danger" onClick={function() { setShowExcluir(item); }}>Excluir</Button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      )}

      <Modal show={showModal} onHide={function() { setShowModal(false); }} size="lg">
        <Modal.Header closeButton className="contas-modal-header">
          <Modal.Title>{editando ? 'Editar Info. Comercial' : 'Nova Info. Comercial'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Data</Form.Label>
                <Form.Control type="date" size="sm" name="data" value={form.data} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label className="small">Empresa</Form.Label>
                <Form.Control type="text" size="sm" name="empresa" value={form.empresa} onChange={handleChange} maxLength={30} />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label className="small">Fone</Form.Label>
                <Form.Control type="text" size="sm" name="fone" value={aplicarMascara(form.fone, 'fone')} onChange={function(e) { var v = String(e.target.value).replace(/\D/g, ''); setForm(function(f) { return { ...f, fone: v }; }); }} maxLength={14} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Contato</Form.Label>
                <Form.Control type="text" size="sm" name="contato" value={form.contato} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Valor</Form.Label>
                <Form.Control type="number" size="sm" step="0.01" name="valor" value={form.valor} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label className="small">Ativo</Form.Label>
                <Form.Control type="number" size="sm" name="codigo_ativo" value={form.codigo_ativo} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group>
            <Form.Label className="small">Informações</Form.Label>
            <Form.Control as="textarea" rows={4} name="informacoes" value={form.informacoes} onChange={handleChange} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowModal(false); }}>Cancelar</Button>
          <Button variant="success" onClick={handleSalvar} disabled={salvando}>
            {salvando ? <Spinner animation="border" size="sm" /> : 'Gravar'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={!!showExcluir} onHide={function() { setShowExcluir(null); }}>
        <Modal.Header closeButton className="contas-modal-header"><Modal.Title>Confirmar Exclusão</Modal.Title></Modal.Header>
        <Modal.Body>Deseja excluir esta informação comercial?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={function() { setShowExcluir(null); }}>Não</Button>
          <Button variant="danger" onClick={handleExcluir}>Excluir</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TabInfoComerciais;
